"use client"

import type { MouseEvent } from "react"

import Link from "next/link"
import { useTranslations } from "next-intl"

import { Button } from "@/components/ui/button"
import { opensElsewhere } from "@/lib/helpers/link-click"

import type { Route } from "next"

interface FeedMoreLinkProps {
  href: Route
  busy?: boolean
  onLoad?: () => void
}

export const FeedMoreLink = ({ href, busy = false, onLoad }: FeedMoreLinkProps) => {
  const t = useTranslations("feed")
  const handleClick = (event: MouseEvent) => {
    if (!onLoad || opensElsewhere(event)) return
    event.preventDefault()
    onLoad()
  }

  return (
    <nav aria-label={t("moreLabel")} className="px-gut mt-flow sr-only flex justify-center focus-within:not-sr-only">
      <Button asChild variant="secondary" size="md" loading={busy}>
        <Link href={href} prefetch={false} scroll={false} onClick={handleClick}>
          {t("more")}
        </Link>
      </Button>
    </nav>
  )
}
